import { useQuery as i } from "@tanstack/react-query";
import { a as s } from "./api.DHdhNbok.js";
import { saveTimestampToLocalStorage as a } from "../utils/storage/index.js";
import { S as n, q as c } from "./stale.constant.De1PuSBj.js";
const m = async (t) => {
  a();
  const o = "api/activity-log", r = new URLSearchParams(t).toString(), e = await s.get(`${o}?${r}`);
  if (!e.ok)
    throw new Error("Error fetching Activity logs data");
  return e.json();
}, f = ({
  queryParams: t,
  enabled: o = !0
}) => i({
  queryKey: c.activityLog(t),
  queryFn: () => m(t),
  staleTime: n,
  refetchOnWindowFocus: !1,
  enabled: o
});
export {
  f as u
};
